import {
  AppConfig,
  CheckUniqueClientMethod,
  DEFAULT_DOCUMENT_TYPE_FILTER_MAX_VISIBLE_CHIPS,
  DEFAULT_LOGO_WIDTH,
  DEFAULT_PROJECT_CARD_IMAGE_ASPECT_RATIO,
  DEFAULT_PROJECT_HERO_IMAGE_ASPECT_RATIO,
  FixationMode,
} from './types/client';

export const defaultAppConfig: AppConfig = {
  ui: {
    primaryColor: 'indigo',
    colors: [],
    primaryShade: 6,
    documentsTypeFilterMaxVisibleChips: DEFAULT_DOCUMENT_TYPE_FILTER_MAX_VISIBLE_CHIPS,
    projectHeroImageAspectRatio: DEFAULT_PROJECT_HERO_IMAGE_ASPECT_RATIO,
    projectCardImageAspectRatio: DEFAULT_PROJECT_CARD_IMAGE_ASPECT_RATIO,
  },
  images: {
    logoUrl: '/static/config/logo-desktop.png',
    mobileLogoUrl: '/static/config/logo-mobile.png',
    logoWidth: DEFAULT_LOGO_WIDTH,
    startImageUrl: '/static/config/cover.png',
    startImageUrlTablet: '/static/config/cover-tablet.png',
    startImageUrlMobile: '/static/config/cover-mobile.png',
    startImageUrlWebp: '/static/config/cover.webp',
    startImageUrlTabletWebp: '/static/config/cover-tablet.webp',
    startImageUrlMobileWebp: '/static/config/cover-mobile.webp',
  },
  logic: {
    booking: {
      // показывать раздел с лотами или нет
      show: true,
      // есть кнопка бронирования или нет
      enabled: true,
      // использовать поле readiness_date для вывода информации о готовности лота
      useReadinessDate: false,
      // показывать ли статус бронирования
      showReservationStatus: true,
    },
    fixation: {
      // выбираем отображение
      mode: FixationMode.SingleWindow,
      // показывать раздел с фиксациями или нет
      show: true,
      // показывать функционал фиксации или нет
      enabled: true,
      // показываемые в форме поля
      shownFields: new Set(),
      // опциональные поля
      optionalFields: new Set(),
    },
    meeting: {
      // показывать раздел с встречами или нет
      show: true,
      // показывать функционал создания встречи или нет
      enabled: true,
      // показываемые в форме поля
      shownFields: new Set(),
      // опциональные поля
      optionalFields: new Set(),
      // показываемые в форме изменения встречи поля
      updateShownFields: new Set(),
      // опциональные поля в форме изменения встречи
      updateOptionalFields: new Set(),
      // показ кнопки "Отменить" во встрече
      showCancelMeetingButton: true,
      // показ кнопки "Изменить" во встрече
      showUpdateMeetingButton: true,
      // показ статуса и фильтрация по статусу встречи
      showStatus: true,
      // проверять уникальность клиента по телефону или телефону и проекту
      checkUniqueClient: CheckUniqueClientMethod.phoneOnly,
      // фильтровать запросы клиентов и заявок по статусу unique
      filterByUniqueClientsAndLeads: true,
      // можно ли редактировать проект при изменении встречи
      canEditProject: true,
      // можно ли редактировать субагента при изменении встречи
      canEditSubAgent: true,
    },
    clientCreation: {
      // показываемые в форме поля
      shownFields: new Set(),
      // опциональные поля
      optionalFields: new Set(),
    },
    subAgentCreation: {
      // показываемые в форме поля
      shownFields: new Set(),
      // опциональные поля
      optionalFields: new Set(),
    },
    employeeCreation: {
      // показываемые в форме поля
      shownFields: new Set(),
      // опциональные поля
      optionalFields: new Set(),
    },
    companyCreation: {
      // показываемые в форме поля
      shownFields: new Set(),
      // опциональные поля
      optionalFields: new Set(),
    },
    placeType: {
      // показывать столбец типов помещений в таблицах или нет
      show: true,
    },
    registration: {
      supportEmail: undefined,
    },
    showContentEditor: [],
    checkUniquePhone: true,
    /** Названия разделов ЛК: documents, projects, meetings, clients, leads, employees, about, lots */
    sectionTitles: {},
  },
};
